/**
 * The period the report on screen shows, for the Alert me sheet.
 *
 * A report page leaves its default period out of the URL, and the sheet reads
 * the URL, so without this it would open with no period chosen.
 * `useReportScope` publishes the named period it resolved and clears it when
 * the page goes. A plain module value, because the sheet reads it once, when
 * it opens.
 */

let current: string | null = null

/**
 * Say which named period the page shows, or that no page shows one.
 *
 * @param period - The period id, or null.
 */
export function publishPagePeriod(period: string | null): void {
  current = period
}

/**
 * The named period the page on screen shows.
 *
 * @returns The period id, or null when no report page is on screen.
 */
export function pagePeriod(): string | null {
  return current
}
